// extracted by mini-css-extract-plugin
module.exports = {"img":"style_img__2N2V8","spinRotation":"style_spinRotation__1doFd","center":"style_center__hA1bs"};